import type { TenantConfig } from '@/types/TenantConfig'

export const huntington: TenantConfig = {
  logo: 'assets/huntington/static/logo.svg',
  teaserImageSize: {
    width: 146,
    height: 146,
  },
  componentOptions: {
    cartWidget: {
      dateTimeFormat: 'ddd D MMM @ h:mm A',
    },
    stripeCreditCard: {
      fontFaceStylesheet: 'https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600&display=swap',
    },
  },
  i18nOverrides: {
    en: {
      homeRoute: {
        title: 'Log in, sign up or continue as a guest',
        loginTitle: 'I am a member',
        signupTitle: 'Become a member',
        guestTitle: 'I am not a member',
        guestButton: 'Shop as a guest',
      },
      membership: {
        title: 'Become a Member',
        renewTitle: 'Renew your Membership',
      },

      namedMembers: {
        roleTitles: {
          member: 'Member Name',
          youth: 'Youth Members',
          'youth-member': 'Youth Members',
        },
        giftTitles: {
          member: 'Recipient Member Name',
          youth: 'Recipient Youth Members',
          'youth-member': 'Recipient Youth Members',
        },
      },

      memberRoleLabels: {
        'third-card': 'additional eCard holder | additional eCard holders',
        'second-card': 'second eCard holder | second eCard holders',
      },

      cartWidget: {
        discounts: 'Adjustments',
      },

      checkoutRoute: {
        title: 'Checkout',
      },
      completedOrdersRoute: {
        title: '<span>Thank you for your order!</span>',
      },
      reserveDateFirst: {
        selectDateLabel: 'Choose a Date',
      },
      selectAvailableSession: {
        title: 'Choose a time',
      },
      selectTickets: {
        title: 'Choose tickets',
      },
      stepperGroupTitles: {
        members: 'Choose the number of member tickets',
        guests: 'Choose the number of non-member tickets',
        default: 'Choose the number of tickets',
      },
      applyPromoCodes: {
        applyAnotherPromoCodeLabel: 'Add another discount code',
        applyPromoCodeLabel: 'Add discount code',
      },
      termsModal: {
        title: 'Release and Waiver of Liability',
      },
    },
  },
  customContent: [
    {
      key: 'member-benefits',
      regions: ['home-member-benefits'],
      template: `
        <div>
          <p>Enjoy unlimited free Huntington admission, access to world - class exhibitions, invitations to fun events and programs, family festivals, plant sale previews, valuable discounts, and much more.</p>

          <p>Delight your senses and enrich your mind with every visit!</p>
        </div>
      `,
    },
    {
      key: 'guest-shopping',
      regions: ['home-guest-experience'],
      template: `
        <p>You can shop as a guest without having to register.</p>
      `,
    },
  ],
}
